export type FormatOptions = {
    shorten?: boolean // Turn on/off shortening of large numbers (e.g., 1k, 1M, 1B)
    decimals?: number // Amount of decimals to show in the formatted number (e.g., 1.23k)
    minSeparated?: number // Min amount of separating thousands with commas (e.g., 1,234,567)
}

export function formatValue(
    value: number | undefined,
    options: FormatOptions = { shorten: false, decimals: 0 },
): string {
    if (value === undefined) {
        return ''
    }
    const { shorten, decimals, minSeparated = 10_000 } = options

    if (shorten) {
        const abs = Math.abs(value)
        const suffixes = [
            { threshold: 1e9, suffix: 'B' },
            { threshold: 1e6, suffix: 'M' },
            { threshold: 1e3, suffix: 'k' },
        ]

        for (const { threshold, suffix } of suffixes) {
            if (abs >= threshold) {
                return (value / threshold).toFixed(decimals) + suffix
            }
        }
    }
    const valueStr = value.toString()
    return value >= minSeparated ? valueStr.replace(/(\d)(?=(\d{3})+$)/g, '$1 ') : valueStr
}

const digitMap: Record<string, string> = {
    '0': '𝟎',
    '1': '𝟏',
    '2': '𝟐',
    '3': '𝟑',
    '4': '𝟒',
    '5': '𝟓',
    '6': '𝟔',
    '7': '𝟕',
    '8': '𝟖',
    '9': '𝟗',
}

export function mapDigitToUnicode(input: string): string {
    return input
        .split('')
        .map((char) => digitMap[char] ?? char) // replace if found, else keep original
        .join('')
}
